var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.count > 0)?[_c('el-badge',{attrs:{"value":_vm.count}},[_vm._t("default")],2)]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }